export default class Totalizers {
  paid = true
  canceled = true
  pending = true
  overdue = true
  unauthorized = true
  disputed = true
}
